import React, { FC } from 'react'
import { useParams } from 'react-router-dom'

import SingleInspectionProvider from './SingleInspectionProvider'

interface Props {
  children?: React.ReactNode
}

const SingleInspectionUrlProvider: FC<Props> = ({ children }) => {
  const { id } = useParams()
  return (
    <SingleInspectionProvider id={id!}>{children}</SingleInspectionProvider>
  )
}

export default SingleInspectionUrlProvider
